import ModalLayoutProvider from './hooks/useModalLayout';
import React from 'react';
import { ModalLayoutProps } from './@types/ModalLayoutProps';
import { useRef } from 'react';
import { Portal } from '@chakra-ui/react';
import { useHandleModal } from '../ModalTrigger/hooks/useHandleModal';

const generateScrollClasses = ({ scroll }: any) => {
	if (scroll?.toLowerCase() == 'body') {
		return 'overflow-y-auto overflow-x-hidden tc';
	} else {
		return 'flex items-center justify-center';
	}
};

const generateScrollClasses2 = ({ scroll }: any) => {
	if (scroll?.toLowerCase() == 'body') {
		return 'dib tl v-mid';
	} else {
		return 'flex flex-column vtex-modal-layout-0-x-paperScrollContent paperScrollContent';
	}
};

const generateFullscreenClasses = ({ fullScreen }: any) => {
	if (fullScreen === false) {
		return 'vtex-modal-layout-0-x-paperNotFullScreen paperNotFullScreen';
	} else {
		return 'vtex-modal-layout-0-x-fullScreenModal fullScreenModal w-100 mw-100 br0 h-100';
	}
};

const ModalLayout = (props: ModalLayoutProps) => {
	const handleModal = useHandleModal();

	const canvasRef = useRef<HTMLDivElement | null>(null);

	React.useEffect(() => {
		const iframe = document.querySelector('iframe')?.contentDocument;
		canvasRef.current = iframe?.querySelector('.canvas') || document.querySelector('.canvas');
	}, []);

	if (!handleModal?.isOpen) {
		return null;
	}
	//adicionando classe DraggableBox como fix para a seleção com botao direito
	//na real o backdrop container fica dentro do vtex-modal-layout-0-x-modal, mas por uma questao de interface, deixamos ele fora aqui no hefesto
	return (
		<ModalLayoutProvider {...props}>
			<Portal containerRef={canvasRef}>
				<div
					data-triggercomponentid={handleModal.triggerComponentId}
					data-selection={props.componentId}
					className={`DraggableBox modal ${props.blockClass ? `modal--${props.blockClass} vtex-modal-layout-0-x-modal--${props.blockClass}` : ''} vtex-modal-layout-0-x-modal`}
					role="presentation"
					style={{ position: 'absolute', inset: '0px', zIndex: 1300 }}
				>
					<div
						onClick={(e) => handleModal?.toggleModal()}
						className={`container container--${props.blockClass} vtex-modal-layout-0-x-container  outline-0 h-100 ${generateScrollClasses(props)}`}
					>
						<div
							onClick={(e) => e.stopPropagation()}
							className={`paper  ${props.blockClass ? `paper--${props.blockClass} vtex-modal-layout-0-x-paper--${props.blockClass}` : ''} vtex-modal-layout-0-x-paper bg-base relative br2  flex flex-column ${generateFullscreenClasses(props)} ${generateScrollClasses2(props)}`}
						>
							{props.children}
						</div>
					</div>
				</div>
				{props.backdrop !== 'none' && (
					<div
						className={`backdropContainer ${props.blockClass ? ` backdropContainer--${props.blockClass} vtex-modal-layout-0-x-backdropContainer--${props.blockClass}` : ''} vtex-modal-layout-0-x-backdropContainer`}
						style={{ opacity: 1, transition: 'opacity 250ms cubic-bezier (0.4, 0, 0.2, 1) 0ms' }}
					>
						<div
							role="presentation"
							className={`backdrop ${props.blockClass ? `${props.blockClass}--backdrop vtex-modal-layout-0-x-backdrop--${props.blockClass}` : ''} vtex-modal-layout-0-x-backdrop  bg-base--inverted o-50 h-100`}
						></div>
					</div>
				)}
			</Portal>
		</ModalLayoutProvider>
	);
};

export default ModalLayout;
